import styled from "styled-components";

export const FilterFieldFixed = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 277px;
  min-width: 0;
`;

export const GrnStatusTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const GrnStatusTag = styled.span`
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  white-space: nowrap;
  background: ${(props) => props.$bg || "#f0f1f4"};
  color: ${(props) => props.$color || "#7b8498"};
`;

export const IconCell = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 14px;
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    color: #767c8f;
  }
`;

export const StateBox = styled.div`
  background: #ffffff;
  border: 1px solid #e6e9ef;
  border-top: 0;
  border-radius: 0 0 16px 16px;
  min-height: 240px;
`;

export const HeaderTagBadge = styled.span`
  border-radius: 8px;
  padding: 8px;
  background: ${(props) => props.$bg || "#fff1e6"};
  color: ${(props) => props.$color || "#e86c37"};
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(232, 108, 55, 0.25);
  border-radius: 8px;
  padding: 12px 16px;
  background: ${(props) => props.$bg || "#fff5e6"};

  img {
    flex-shrink: 0;
  }
`;

export const GrnSummaryCardDesktop = styled.div`
  border: 1px solid #e6e9ef;
  border-radius: 16px;
  padding: 24px;
  background: #ffffff;
`;

export const GrnSummaryTitle = styled.h2`
  margin: 0 0 20px;
  color: #293142;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
`;

export const GrnSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px 24px;
`;

export const GrnSummaryField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;

  span:first-child {
    color: #767c8f;
    font-size: 14px;
    line-height: 20px;
  }

  span:last-child {
    color: #293142;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    overflow-wrap: anywhere;
  }
`;

export const ClaimText = styled.span`
  display: block;
  color: rgba(232, 108, 55, 1);
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
`;

export const CellStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const LinkButton = styled.button`
  border: 0;
  padding: 0;
  background: none;
  color: #ef4f5f;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
`;

export const StepLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StepBody = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: ${(props) => (props.$flush ? "0" : "24px")};
`;

export const StepFooter = styled.div`
  flex-shrink: 0;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px -4px 6px rgba(28, 28, 28, 0.06);
`;

export const StepHeading = styled.h2`
  margin: 0 0 16px;
  color: #293142;
  font-size: ${(props) => (props.$large ? "24px" : "16px")};
  font-weight: 600;
  line-height: ${(props) => (props.$large ? "30px" : "22px")};
`;

export const StepSubheading = styled.p`
  margin: -8px 0 24px;
  color: #767c8f;
  font-size: 12px;
  line-height: 16px;

  strong {
    color: #293142;
    font-weight: 600;
  }
`;
